import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, Check } from "lucide-react";

export function Select({ value, onChange, options, label, placeholder = "Select…", testid }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const selected = options.find((o) => o.value === value);

  return (
    <div className="block" ref={ref}>
      {label && (
        <span className="block text-[11px] uppercase tracking-wider text-muted mb-1.5">
          {label}
        </span>
      )}
      <div className="relative">
        <button
          type="button"
          data-testid={testid}
          onClick={() => setOpen((o) => !o)}
          className="w-full h-9 px-3 flex items-center justify-between bg-surface2 border border-line rounded-sm text-sm text-ink transition-colors duration-150 hover:border-lineFocus focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/40"
        >
          <span className={selected ? "text-ink" : "text-faint"}>
            {selected ? selected.label : placeholder}
          </span>
          <ChevronDown className="w-4 h-4 text-muted" />
        </button>
        {open && (
          <div className="absolute z-50 mt-1 w-full max-h-64 overflow-auto bg-surface2 border border-lineFocus rounded-sm shadow-2xl animate-fadeup">
            {options.map((o) => (
              <button
                key={o.value}
                type="button"
                data-testid={testid ? `${testid}-opt-${o.value}` : undefined}
                onClick={() => {
                  onChange(o.value);
                  setOpen(false);
                }}
                className="w-full px-3 py-2 flex items-center justify-between text-left text-sm text-ink hover:bg-primary/15 transition-colors duration-100"
              >
                <span>{o.label}</span>
                {o.value === value && <Check className="w-3.5 h-3.5 text-primary" />}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
